import { Component, OnInit, Inject, Renderer2, OnDestroy } from '@angular/core';
import { Router, Data, ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "@services/authentication.service";
import { first, debounce } from 'rxjs/operators';

import { CommonService } from '@services/app.common.service';
import { HttpClient } from '@angular/common/http';
import { StatusCode } from '../_shared/_enums/Common';


@Component({
    selector: 'app-forgotPassword',
    templateUrl: './forgotPassword.component.html',
    styleUrls: ['./forgotPassword.component.css'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  user = {
    userName: '',
    password: ''
  }
  public error = '';
  public success = '';
  data = [];
  public _http;
  public _baseUrl;
  public StatusCode = StatusCode;
  public tokenResponse: any;
  public loading: boolean = false;
  public emailMessage: boolean = true;

  constructor(private router: Router, private route: ActivatedRoute, public common: CommonService, public authService: AuthenticationService, http: HttpClient, @Inject('BASE_URL') baseUrl: string, private renderer: Renderer2) {
    this.user = {
      userName: '',
      password: ''
    }

    this._http = http;
    this._baseUrl = baseUrl;

    this.renderer.removeClass(document.body, 'body-class');
    this.renderer.addClass(document.body, 'body-class-login');
  }

  ngOnInit() {

    this.loading = true;
    ;
    this.route.data.subscribe((data: Data) => {
      this.tokenResponse = data['tokenResponse'];
      this.loading = false;


    });

  }
  ngOnDestroy() {

  }

  getTranslationFile() {
    this.common.PostData('Translation/GetTranslationFile', navigator.language).then(data => {
      this.data = data;
    });
  }

  forgotPassword() {

    var userName = this.user.userName;
    var $this = this;
    this.common.SetAccessToken(this.tokenResponse.resultData);
    this.loading = true;
    this.common.GetData(this.common.ApiUrls.ForgotPassword.ForgotPassword + this.user.userName, true).then(function (data) {
      ;
      if (data.status == StatusCode.OK) {

        $this.success = 'We have emailed you the link to update your password. Please check your email';
        $this.error='';
        $this.common.RemoveAccessToken();  
      }
      else if (data.status == StatusCode.partialContent) {
        $this.error = 'Something  went wrong  . Please contact to administration';
        $this.success = '';
        $this.emailMessage = false;
      }
      else {
        $this.common.RemoveAccessToken();
      
      }
      $this.loading = false;
    });
  }
}


